

export class Boundries {
    
    left?: number;
    right?: number;
    top?: number;
    bottom?: number;

    constructor(){
        this.left = 0
        this.right = 0
        this.top = 0
        this.bottom = 0
    }

    init(left: number, right: number, top: number, bottom: number) {
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom  = bottom;
    }

    public retrieve(deltaX: number, deltaY: number): void {

        if(this.left! !== 0) {
            this.left! -= deltaX

            if(this.left! < 0) {
                this.left! = 0
            }
        }

        if(this.right! !== 0) {
            this.right! -= deltaX

            if(this.right! < 0) {
                this.right! = 0
            }
        }

        if(this.top! !== 0) {
            this.top! -= deltaY

            if(this.top! < 0) {
                this.top! = 0
            }
        }

        if(this.bottom! !== 0) {
            this.bottom! -= deltaY

            if(this.bottom! < 0) {
                this.bottom! = 0
            }
        }
    }
}